import Utils from 'nova-tn-frontend/source/scripts/modules/Utils';

var HeroMediaInit = {
    data: {
        heroMedia: $('.c-article-wrapper.-hero .c-player').first().parent().parent(),
        isResponsive: null
    },
    Init: function() {
        let image = HeroMediaInit.data.heroMedia.find('.img');
        let video = HeroMediaInit.data.heroMedia.find('.c-player');

        if (HeroMediaInit.data.heroMedia.length > 0 && image.length > 0 && video.length > 0) {
            if (HeroMediaInit.data.isResponsive === Utils.IsResponsive()) {
                return;
            }

            HeroMediaInit.data.isResponsive = Utils.IsResponsive();
            setTimeout(function() {
               HeroMediaInit.ChangeMedia();
           }, 2000);
        }
    },
    ChangeMedia: function() {
        if (HeroMediaInit.data.isResponsive) {
            // HeroMediaInit.ReloadVideo('no');
            // HeroMediaInit.data.heroMedia.find('article>.c-player').first().hide();
            let heroImg = HeroMediaInit.data.heroMedia.find('.img');
            // heroImg.first().fadeIn(1000);
            if (heroImg.find('img').first().attr('src') === undefined) {
                heroImg.find('img').first().attr('class', 'lazyload');
            }
        }else{
          HeroMediaInit.data.heroMedia.find('.c-player').parent().next().css({ marginRight: '-35px' }).animate({ marginRight: '0px' }, 1000); 
        }
        HeroMediaInit.data.heroMedia.find('.c-player').css({ opacity: 0 }).animate({ opacity: 1 }, 1000);

        HeroMediaInit.ReloadVideo('any');
    },
    ReloadVideo: function(autoplayState) {
        let frame = HeroMediaInit.data.heroMedia.find('.kframe').clone();
        let frameID =  HeroMediaInit.data.heroMedia.find('.kframe').data("video-id");
        // eslint-disable-next-line no-useless-escape
        frame.get(0).src = frame.get(0).src.replace(/(\?)autoplay=\w+|(\&)autoplay=\w+/g, '$1$2autoplay=' + autoplayState);
        HeroMediaInit.data.heroMedia.find('.kframe').first().parent().html('').html(frame);
        play(frameID);

        
    }
};

$( window ).on( 'resize', function() {
    HeroMediaInit.Init();
});

function play(videoId) {
    $.klebetnica({
        setMuted: true,
        option: true,
        initiator: videoId
    });
    $.klebetnica({
        playPlayer: true,
        initiator: videoId
    });
}

// module.exports = HeroMediaInit;

export default HeroMediaInit;
